import styled, { css } from 'styled-components';

import { ReactComponent as CloseIcon } from '../../../assets/images/blueTheme/X.svg';
import { NotificationType } from './types';

export const NotificationsWrapper = styled.div<{
  $backgroundColor: string;
  $backgroundBorderColor: string;
  $color: string;
}>(
  ({ theme: { spacers }, $backgroundColor, $backgroundBorderColor, $color }) => css`
    display: flex;
    align-items: center;
    padding: ${spacers!.spacer03} ${spacers!.spacer11};
    background-color: ${$backgroundColor};
    border: 1px solid ${$backgroundBorderColor};
    color: ${$color};
    width: 100%;
    font-family: InspireTWDC;
    min-height: 48px;
    height: fit-content;
  `
);

export const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const IconWrapper = styled.div<{ $color: string }>(
  ({ $color }) => css`
    path {
      fill: ${$color};
    }
  `
);

export const CloseWrapper = styled.div(
  ({ theme: { spacers } }) => css`
    display: flex;
    align-items: center;
    margin-left: auto;
    padding-left: ${spacers!.spacer03};
  `
);
export const Close = styled(CloseIcon)<{ $color: string }>(
  ({ $color }) => css`
    cursor: pointer;

    path {
      fill: ${$color};
    }
  `
);

export const Text = styled.div(
  ({ theme: { spacers } }) => css`
    padding-left: ${spacers!.spacer02};
    color: inherit;
    font-size: 14px;
    line-height: 21px;
  `
);

export const Title = styled(Text)<{ type?: NotificationType }>(
  ({ type }) => css`
    font-weight: ${type === NotificationType.info ? '700' : '500'};
  `
);
